import React from 'react';

const Benefits = ({ language }) => {
  const texts = {
    lt: {
      eyebrow: 'Pastabos forma',
      title: 'Pastaba ne klasifikuoja. Ji paruošia vakarą.',
      subtitle: 'Kiekviena pastaba laikosi to paties trumpo formato, kad pasirinkimas būtų ramus.',
      rows: [
        { label: 'Nuotaika', value: 'Naktinis miestas' },
        { label: 'Tempas', value: 'Lėtas, su tyliomis pauzėmis' },
        { label: 'Kam tinka', value: 'Vienam vakarui po darbo' },
      ],
      alt: 'Juostos ritė ir kino salės šviesa',
      caption: 'Pavyzdys, kaip atrodo pastaba',
    },
    en: {
      eyebrow: 'Note format',
      title: 'A note does not rank a film. It prepares the evening.',
      subtitle: 'Every note follows the same short format, so the choice stays calm.',
      rows: [
        { label: 'Mood', value: 'Night city' },
        { label: 'Pace', value: 'Slow, with quiet pauses' },
        { label: 'Fits', value: 'A solo evening after work' },
      ],
      alt: 'A film reel and cinema light',
      caption: 'A sample of how a note is shaped',
    },
  };

  const t = texts[language];

  return (
    <section id="section-4" className="border-b border-white/10 py-20">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-2">
        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-amber">{t.eyebrow}</p>
          <h2 className="mt-4 font-heading text-4xl text-paper sm:text-5xl">{t.title}</h2>
          <p className="mt-4 text-lg text-sand">{t.subtitle}</p>
          <dl className="mt-8 border-t border-white/10">
            {t.rows.map((row) => (
              <div key={row.label} className="grid gap-2 border-b border-white/10 py-5 sm:grid-cols-[140px_1fr]">
                <dt className="text-xs uppercase tracking-[0.18em] text-amber">{row.label}</dt>
                <dd className="text-paper">{row.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <figure>
          <img
            src="https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80"
            alt={t.alt}
            className="h-[460px] w-full object-cover"
          />
          <figcaption className="mt-3 text-xs uppercase tracking-[0.18em] text-sand">{t.caption}</figcaption>
        </figure>
      </div>
    </section>
  );
};

export default Benefits;
